/* eslint-disable @typescript-eslint/no-explicit-any */
import * as XLSX from "xlsx-js-style";

interface XLSXOptions {
  filename?: string;
  sheetName?: string;
}

const FILENAME_DATE = new Date().getTime();
const FILENAME_MODULE = "Voucher_Report";
const FILENAME = `${FILENAME_MODULE}-${FILENAME_DATE}`;

export const ExportToXLSX = <T extends Record<string, unknown>>(
  jsonData: T[],
  options: XLSXOptions = {}
): void => {
  const {
    filename = `${FILENAME}.xlsx`,
    sheetName = "Voucher Redemption Count Report",
  } = options;

  if (!jsonData?.length) return;

  const headers = Object.keys(jsonData[0]);
console.log("headers", headers)
  const getNestedValue = (obj: any, path: string): any =>
    path.split(".").reduce((acc, key) => (acc && acc[key] != null ? acc[key] : ""), obj);

  const rows = jsonData.map(row =>
    headers.map(h => {
      const value = getNestedValue(row, h);

      if (Array.isArray(value)) return value.join(", ");

      return value;
    })
  );

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // Style header row (bold + gray)
  headers.forEach((_, colIndex) => {
    const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: colIndex })];
    if (cell) {
      cell.s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "E7E6E6" } },
      };
    }
  });

  // Force ALL cells to string
  const range = XLSX.utils.decode_range(worksheet["!ref"] || "");

  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    for (let C = 0; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellAddress];

      if (cell && cell.v != null) {
        cell.t = "s"; // force string
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  XLSX.writeFile(workbook, filename);
};
